/* unplugin-vue-components disabled */import { render } from "./ExamTrainView.vue?vue&type=template&id=70adf1c6&scoped=true"
import script from "./ExamTrainView.vue?vue&type=script&lang=js"
export * from "./ExamTrainView.vue?vue&type=script&lang=js"

import "./ExamTrainView.vue?vue&type=style&index=0&id=70adf1c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70adf1c6"]])

export default __exports__